import { AxiosInstance } from "axios";

export default class CommonService {
  private axios: AxiosInstance;
  constructor(axios: AxiosInstance) {
    this.axios = axios;
  }

  public async getMany<ItemT>(
    resource: string,
    page?: number,
    itemsPerPage?: number,
    extraQueryParams: string = "",
    signal?: AbortSignal
  ): Promise<LAVPagination<ItemT>> {
    const pageParam = page ? `page=${page}` : "";
    const itemsParams = itemsPerPage ? `items=${itemsPerPage}` : "";
    const params = [];
    if (pageParam) params.push(pageParam);
    if (itemsParams) params.push(itemsParams);
    if (extraQueryParams) params.push(extraQueryParams);
    const queryParams = params.join("&");
    const url: string = `/${resource}?${queryParams}`;
    return this.axios.get(url, {signal});
  }

  public async getData(resource: string): Promise<LAVDataRow[]> {
    const url: string = `/${resource}/data`;
    return this.axios.get(url);
  }

  public async getOne<ItemT>(resource: string, id: string): Promise<ItemT> {
    const idParam = id ? `/${id}` : "";
    const url: string = `/${resource}${idParam}`;
    return this.axios.get(url);
  }
}
